import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
import { Vector2LineComponent } from "shared-ui-components/lines/vector2LineComponent.js";
import { Vector2 } from "core/Maths/math.vector.js";
/**
 * The property tab component for InputBlock of type ConnectionPointType.Vector2.
 */
export class Vector2PropertyTabComponent extends Component {
    // eslint-disable-next-line babylonjs/available
    render() {
        const value = this.props.inputBlock.runtimeValue.value;
        const target = {
            value: new Vector2(value.x, value.y),
        };
        return (_jsx(Vector2LineComponent, { lockObject: this.props.lockObject, label: this.props.inputBlock.name, target: target, propertyName: "value", onChange: () => {
                value.x = target.value.x;
                value.y = target.value.y;
                this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.inputBlock);
            } }, this.props.inputBlock.uniqueId));
    }
}
//# sourceMappingURL=vector2PropertyTabComponent.js.map